import React from 'react';
import { GalleryHeroSectionProps } from '../../../../../Sections/Gallery/HeroSection/HeroSection';
import * as classes from './HeroSection.module.scss';
import Container from '../../../../../Common/Container/Container';

const HeroSection = ({ pageTitle }: GalleryHeroSectionProps) => {
  return (
    <Container className={classes.wrapper}>
      <h1 data-aos='fade-in'>{pageTitle}</h1>
    </Container>
  );
};

export default HeroSection;
